import React from "react";
import johirul from "../../assets/shahjahirul.jpg";
const Stroke = () => {
  return (
    <div>
      {/* <p>Stroke</p> */}
      <div className="blog">
         
        

        <div>
          <p className=" max-w-lg mt-7 mb-5 md:text-[20px] lg:text-[27px]   px-8  font-bold  py-2  text-justify   lg:mx-16 mx-8 ">
            Stroke: Treatment and prevention through awareness
          </p>
          <p className=" max-w-lg  md:text-[20px] lg:text-[15px]   px-8  font-bold mb-2    text-justify   lg:mx-16 mx-8 ">
            Prof. Dr. Mohammad Shah Jahirul Hoque Chowdhury Professor (Clinical
            Neurology) National Institute of Neurosciences & Hospital (NINS)
            Sher-e-Bangla Nagar, Dhaka
          </p>
          <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
            <p className="px-8">
              If you had to do all your daily work without using your one hand,
              one leg, and one portion of the face, you might be able to imagine
              how critically stroke-affected patients have to spend their lives.
              A brain stroke causes a severe medical condition due to
              complications in the brain’s blood vessels. The cells in our
              brains are extremely sensitive. Even a little lack in the supply
              of oxygen and carbohydrate causes the cells to start to decay. If
              the blood flow to any part of the brain is hampered (except due to
              injuries) and continues to sustain for twenty-four hours or the
              patient dies by twenty-four hours – then it might be a case of a
              stroke.
            </p>
          </div>
        </div>
        <div className="py-2   text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            A stroke could be detected through severe symptoms like paralysis;
            in some cases, it might even lead to death. In most cases, one
            particular side of the patient’s body, including hand, leg, and
            face, are paralyzed. If the left side of the brain is affected by a
            stroke, then the right side of the body will be paralyzed, and
            vice-versa. It indicates that the limbs controlled by the affected
            portion of the brain will suffer the impact. The type and severity
            of the stroke determine the type and severity of the paralysis. Many
            of us carry a misconception that stroke and heart attack are the
            same. We have to remember that stroke is not heart disease; it is
            mainly related to our brain. Hospitals have separate specialized
            units for both cardiac and stroke treatments, and different
            specialist doctors for each unit; if a stroke patient is diagnosed
            early and taken to the hospital on time, the chances of their safe
            recovery increases by quite some extent.
          </p>
        </div>
        {/* <div className="py-2   text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            Men are 1.5 times more likely to be diagnosed with PD than women,
            according to Parkinson's Foundation. The disease's risk increases
            with age, but some are diagnosed at early years, like before the age
            of 50. Most of the time, PD is not hereditary, but some people can
            inherit it due to altered genes. According to Harvard Health
            Publishing, numerous studies have shown that individuals can have PD
            if they are exposed to chemicals used in pesticides, herbicides, and
            organic pollutants. Repeated blows on the head can also increase the
            risk of developing PD.
          </p>
        </div> */}
        <div className="py-2   text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            Stroke symptoms include sudden weakness or unresponsiveness of one
            side of the body, headache, vomiting, sudden fainting, difficulty,
            or inability to speak. A stroke-patient might feel dizzy and have
            severe pain in their head, neck, face, and even between their eyes.
            The patient might face difficulty to walk or balance themselves;
            their words might sound mumbled. Blurry eyesight and nausea can also
            indicate the same. Remembering the acronym ‘FAST’ is recommended to
            diagnose and care for a stroke-patient, where F is for ‘facial
            deformation’ or droopiness, A is for ‘arm weakness’, S is for
            ‘speech impediment.’ T is for ‘Time to seek emergency healthcare’.
            When a patient is found to fulfill these criteria, we must not
            panic. Instead, we have to quickly reach the nearest hospital
            emergency and avail medical attention within the shortest possible
            time. Patients suffered by a stroke could be cured with timely
            medical attention.
          </p>
        </div>
        <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            Stroke can be of two types, depending on how it affects the brain.
            These are 1. Ischemic stroke, and 2. Hemorrhagic stroke. If blood is
            clotted inside the brain’s vessels or clotted-blood is circulated
            from the heart or any other limb to the brain – then there are high
            chances of an ischemic stroke. Although the rate of fatality from
            ischemic stroke is comparatively low, the recovery phase for the
            sufferer is longer, and in many cases, patients have to live with
            permanent paralysis. In the case of a hemorrhagic stroke, blood
            vessels are broken, followed by bleeding inside the brain. Signs and
            symptoms in such cases depend on the location and severity of the
            impact on the brain. In most cases, patients arrive at the hospitals
            in an unconscious state or with high blood pressure. The chances of
            death are higher in hemorrhagic strokes. Patients who overcome the
            primary strain have lower chances of facing a second hemorrhage.
            They face a lesser risk of permanent paralysis, and the initial
            paralysis is also cured within a comparatively lesser duration.
          </p>
        </div>
        <div>
          <p className=" max-w-lg mt-7 mb-7 md:text-[20px] lg:text-[27px]   px-8  font-bold  py-2  text-justify   lg:mx-16 mx-8 ">
            Treatment for Stroke:
          </p>
          <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
            <p className="px-8">
              Whichever type of stroke a patient suffers from, his/her recovery
              depends mainly on how quickly, efficiently, and properly the
              primary treatment and rehabilitation process is provided. Certain
              patients can be treated by thrombolysis (melting blood-clots using
              injections) and thrombectomy (taking out blood-clots using
              stents), if brought to the hospital within 3 – 4 hours of
              suffering from an ischemic stroke. In other cases, the doctor
              needs to operate extensive investigation and advise medicines and
              rehabilitations accordingly. Besides primary treatments,
              hemorrhagic strokes can be treated by surgery, surgical clipping,
              or coiling.
            </p>
          </div>
        </div>
        <div className="py-2   text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            Few more remedies are recommended to be applied; for example: if
            there is a shortness of breathing or no breathing, then the patient
            needs to be artificially respirated by mouth-to-mouth breathing. If
            the patient is vomiting, then the head needs to be placed sideways.
            Those looking after should remember to not feed the patient anything
            solid or liquid. The respiration, respiratory channel, and blood
            circulation need to be constantly monitored for unconscious
            patients. The patient needs to be laid sideways. Proper care of the
            eyes the bladder should be taken, even using a catheter, if
            required. At least two persons shall be at the hospital along with
            the patient. This will ensure smoother progress of the diagnosis and
            treatment.
          </p>
        </div>

        <div>
          <p className="max-w-lg mt-7 mb-7 md:text-[20px] lg:text-[27px]   px-8  font-bold  py-2  text-justify   lg:mx-16 mx-8 ">
            Causes of Stroke:
          </p>
          <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
            <p className="px-8">
              Over 55-years of age have higher risks of stroke. Men are more
              vulnerable to strokes compared to women. High blood pressure,
              diabetes, cardiac diseases, and obesity are some of the underlying
              causes of stroke. Previous cases of stroke or heart attack in the
              family, smoking or alcohol consumption, heart diseases like
              irregular heartbeat, heart failure, heart infection, hormone
              therapy or birth-control medicines, previous history of one or
              more strokes or Transient Ischemic Attack (TIA) can also increase
              the chances of a stroke.
            </p>
          </div>
        </div>
        <div>
          <p className="max-w-lg mt-7 mb-7 md:text-[20px] lg:text-[27px]   px-8  font-bold  py-2  text-justify   lg:mx-16 mx-8  ">
            Preventives:
          </p>
          <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
            <p className="px-8">
              Stroke is mostly preventable. But it is required to raise
              awareness to prevent this disease, which is why all should know
              about the risks of stroke and abide by the rules for a healthy
              lifestyle. To maintain a healthy lifestyle, one should regularly
              check their blood pressure and take necessary steps to keep it
              under control, avoid high-fat foods, control their cholesterol
              levels, check diabetes regularly, keep alert about this, maintain
              physical exercise, and control their weight. Vegetables, small
              fish, sea-fish, dried fish, and milk shall be included in the
              diet. Patients could face paralysis, coma, or even death due to a
              stroke. But a little awareness and timely treatments can result in
              up to 50% improvement of the patients’ condition. A healthy
              lifestyle can lessen the risks of stroke by a large margin. Stroke
              Day is celebrated around the world on October 29 every year.
              Stroke-related illness and mortality are a matter of concern for
              people all over the world. It is great that stroke awareness among
              the people in our country is now slowly increasing. We want to
              move forward with modern medical management of stroke and public
              awareness about stroke.
            </p>
          </div>
        </div>
        <div className="py-2  text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            <span className="font-bold">Disclaimer:</span> “Any and all the
            Information provided in the article are independent views expressed
            by Prof. Dr. Mohammad Shah Jahirul Hoque Chowdhury, Professor
            (Clinical Neurology), National Institute of Neurosciences & Hospital
            (NINS) for general overview and educational purposes only.”
          </p>
        </div>
        {/* <div className="py-2    text-justify   lg:mx-16 mx-8     grid grid-cols-1 lg:grid-cols-1   justify-items-center items-center">
          <p className="px-8">
            PD patients should consult with doctors about DBS when medications
            alone aren't providing enough relief but still have some effect. It
            is also recommended to consider the therapy before PD's symptoms
            have progressed beyond 'the window of opportunity,' which means when
            the symptoms stop responding to medication. Moreover, people should
            consult with doctors about PD as early as possible cause any
            disorder in the brain can cause severe complications in life. Dr
            Mohammad Shah Jahirul Hoque Chowdhury, Professor (Clinical
            Neurology), National Institute of Neurosciences & Hospital (NINS),
            Sher-e-Bangla Nagar, Dhaka
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Stroke;
